export const borderSize = '4px';
export const mobileBreakpoint = '35em';
export const cursorUrl = '/assets/cursor.png';
export const cursorClickUrl = '/assets/cursor-click.png';
